module.exports = __webpack_public_path__ + "e543b492e48e5560f6f6e87cf14747ae.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/winking-28.png
// module id = 2395
// module chunks = 0